import { gql } from "urql";

export const GET_ENTITIES_BY_OWNER: any = gql(`
    query GetEntitiesByOwner($ownerId: String!){
        GetEntitiesByOwner(ownerId: $ownerId){
            _id
            name
            loans {
                _id
            }
            referenceEntity {
                _id
            }
            ownerships {
                _id
                name
                lastname
                stakes
                ssn
                phone
                email
                address
                dateBirth
                files {
                    key
                    name
                    url
                }
            }
        }  
    }
`)


export const GET_ENTITY_BY_LOAN: any = gql(`
    query GetEntityByLoan($loanId: String!){
        GetEntityByLoan(loanId: $loanId){
            _id
            name
            loans {
                _id
            }
            referenceEntity {
                _id
            }
            ownerships {
                _id
                name
                lastname
                stakes
                ssn
                phone
                email
                address
                dateBirth
                files {
                    key
                    name
                    url
                }
            }
        }  
    }
`)

export const GET_DOCS_BY_ENTITY: any = gql(`
    query GetEntityDocsByEntity($entityId: String!){
        GetEntityDocsByEntity(entityId: $entityId){
            _id
            key
            label
            description
            files {
                key
                name
                url
                state
            }
            entity {
                _id
            }
        }  
    }
`)

export const GET_ENTITIES_LIST_BY_OWNER: any = gql(`
    query GetEntitiesListByOwner($search: String, $page: Int, $limit: Int){
        GetEntitiesListByOwner(search: $search, page: $page, limit: $limit){
            data {
                _id
                name
                loans {
                    _id
                    name
                    type
                    progress
                    state
                    tasks {
                      _id
                      name
                      key
                      state
                      phase
                      hidden
                    }
                }
                referenceEntity {
                    _id
                }
                docs {
                    _id
                    label
                    state
                }
                ownerships {
                    _id
                    name
                    lastname
                    stakes
                    ssn
                    phone
                    email
                    address
                    dateBirth
                    state
                    files {
                        key
                        name
                        url
                    }
                }
            }
            total
            page
            totalPages
        }  
    }
`)